import React from 'react';
import { SelectField, InputLabels } from '../../generic/InputField';
import styles from './index.module.scss';

export default function MountingOptions({ product: { id, productMounts }, onSelectedMount }) {
  if (!productMounts || productMounts.length === 0) return null;

  const productMountsArr = productMounts?.map(({ mount }) => ({
    value: mount.id,
    displayValue: mount.heading,
  }));

  const selectId = `mount-${id}`;
  return (
    <form name="main-list-mount-selector" className={styles.mountingOptions}>
      <InputLabels htmlFor={selectId} id="mount">
        <SelectField
          id={selectId}
          name="mount"
          handleSelectChangeCallback={onSelectedMount}
          options={productMountsArr}
          defaultValue={productMountsArr[0].value}
        />
      </InputLabels>
    </form>
  );
}
